import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Tabs, Tab } from '@mui/material';
import TemplatePage from '../TemplatePage';
import Headerr from '../../Headerr';
import { WalletStyles } from './styles';
import WalletDashboard from './WalletDashboard';
import WalletSend from './WalletSend';
import WalletReceive from './WalletReceive';
import WalletHistory from './WalletHistory';
import WalletOrdinals from './WalletOrdinals';
import WalletAccounts from './WalletAccounts';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const TabPanel: FC<TabPanelProps> = ({ children, value, index }) => {
  return (
    <div role="tabpanel" hidden={value !== index} style={{ width: '100%' }}>
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
};

const Wallet: FC = () => {
  const { t } = useTranslation();
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  return (
    <TemplatePage>
      <Box sx={WalletStyles.mainContainer}>
        <Headerr passedData="wallet" />

        <Box sx={WalletStyles.tabsContainer}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              '& .MuiTab-root': {
                color: 'rgba(123, 162, 56, 0.5)',
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '0.85rem',
                minWidth: 'auto',
                padding: '8px 16px',
              },
              '& .Mui-selected': {
                color: '#7BA238 !important',
                fontWeight: 700,
              },
              '& .MuiTabs-indicator': {
                backgroundColor: '#7BA238',
              },
            }}
          >
            <Tab label={t('wallet.tabBalance')} />
            <Tab label={t('wallet.tabSend')} />
            <Tab label={t('wallet.tabReceive')} />
            <Tab label={t('wallet.tabHistory')} />
            <Tab label={t('wallet.tabOrdinals')} />
            <Tab label={t('wallet.tabAccounts')} />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <WalletDashboard />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <WalletSend />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <WalletReceive />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <WalletHistory />
        </TabPanel>
        <TabPanel value={tabValue} index={4}>
          <WalletOrdinals />
        </TabPanel>
        <TabPanel value={tabValue} index={5}>
          <WalletAccounts />
        </TabPanel>
      </Box>
    </TemplatePage>
  );
};

export default Wallet;
